import React from "react";
import { Helmet } from "react-helmet"; // TODO Remove if using NextJS

type Props = {
  title: string;
};

const SetMetaTags = ({ title }: Props) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

export default SetMetaTags;
